import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
// import SettingsIcon from "@mui/icons-material/Settings";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import useItem from "../../services/queries/useItem";
import useUser from "../../services/queries/useUser";
import useKategori from "../../services/queries/useKategori";
import ModalStok from "../../components/ModalStok/ModalStok";
import ModalMutasiStok from "../../components/ModalMutasiStok/ModalMutasiStok";
import ModalDetailBarang from "../../components/ModalDetailBarang/ModalDetailBarang";
import toRupiah from "../../utils/toRupiah";
import avatarAlt from "../../utils/avatarAlt";
import { useAuth } from "../../context/authContext";
import { useTransaksi } from "../../context/transaksiContext";
// import { useStokModal } from "../../context/stokModalContext";
// import { useImportModal } from "../../context/importModalContext";
import { useKatalogModal } from "../../context/katalogModalContext";
// import { useKategoriModal } from "../../context/kategoriModalContext";
import { useHapusStokModal } from "../../context/hapusStokModalContext";
import { useHapusMultipleStokModal } from "../../context/hapusMultipleStokModalContext";
// import { useMutasiStokModal } from "../../context/mutasiStokModalContext";
import { usePrintBarcodeModal } from "../../context/printBarcodeModal";
import {
    // ContentGetItemResponse,
    // IOptions,
    ParamsGetItem,
    ParamsGetKategori,
    ParamsGetWarehouse,
    SelectedProductBundling,
} from "../../constants/types";
import { ReactComponent as BarangTidakDitemukan } from "../../assets/images/BarangTidakDitemukan.svg";
import Spinner from "../Spinner/Spinner";
import NoRowsImage from "../NoRowsImage/NoRowsImage";
import LoadingTabel from "../LoadingTabel/LoadingTabel";
import CardStokBarang from "../CardStokBarang/CardStokBarang";
import ModalDeleteStok from "../ModalDeleteStok/ModalDeleteStok";
import ModalDeleteMultipleStok from "../ModalDeleteMultipleStok/ModalDeleteMultipleStok";
// import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { Search } from "@mui/icons-material";
import truncate from "../../utils/truncate";
import toRibuan from "../../utils/toRibuan";
import moment from "moment";
import "moment/locale/id";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Tooltip } from "@mui/material";
import { mapStockFieldSorting } from "../../utils/mapStockFieldSorting";

import CloseIcon from "@mui/icons-material/Close";

import Collapse from "@mui/material/Collapse";
import { getLocalWarehouseId } from "../../utils/handleChangeWarehouseId";
import useWarehouse from "../../services/queries/useWarehouse";
import { useDetailBarangModal } from "../../context/detailBarangModalContext";

moment.locales();
moment.locale("id");

interface ITabelBarangProps {}

const TabelBarang = (props: ITabelBarangProps) => {
    const theme = useTheme();
    const { warehouseIdUser } = useAuth();
    const { openModalPrintBarcode } = usePrintBarcodeModal();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));
    // const isDesktopScreen = useMediaQuery(theme.breakpoints.up("xl"));

    const initialParamsItem = {
        warehouseId: warehouseIdUser && warehouseIdUser[0],
        size: 10,
        page: 1,
        isShow: 0,
        search: "",
        kategori: "",
    };
    const [paramsItem, setParamsItem] =
        useState<ParamsGetItem>(initialParamsItem);
    const {
        data: dataItem,
        refetch: refetchItem,
        isLoading: isLoadingItem,
    } = useItem(paramsItem);

    const initialParamsKategori = {
        warehouseId: Number(warehouseIdUser && warehouseIdUser[0]),
        size: 500,
        page: 1,
        search: "",
    };
    const [paramsKategori, setParamsKategori] = useState<ParamsGetKategori>(
        initialParamsKategori,
    );
    const {
        status: statusKategori,
        data: dataKategori,
        refetch: refetchKategori,
    } = useKategori(paramsKategori);
    // const initialParamsWarehouse = {
    //     size: 500,
    //     page: 1,
    //     search: "",
    // };
    // const { data: warehouse } = useWarehouse(initialParamsWarehouse);
    const { data: user } = useUser();
    const [kategori, setKategori] = useState("");
    // const [selectedKategori, setSelectedKategori] = useState<IOptions | null>(
    //     null,
    // );

    // const warehouseId = React.useMemo(() => {
    //     if (user?.userId) {
    //         return getLocalWarehouseId(user?.userId);
    //     }
    //     return null;
    // }, [user?.userId]);

    // const warehouseData = React.useMemo(() => {
    //     if (warehouseId) {
    //         return warehouse?.content.find((li) => li.id === warehouseId);
    //     }
    //     return warehouse?.content[0];
    // }, [warehouse?.content, warehouseId]);

    const { isFetchingItems, cancelFetchingItems } = useTransaksi();

    // const { openModal } = useStokModal();
    // const { openModalImport } = useImportModal();
    const { openModalKatalog } = useKatalogModal();
    // const { openModalKategori } = useKategoriModal();
    const { openModalHapusStok } = useHapusStokModal();
    const { openModalHapusMultipleStok } = useHapusMultipleStokModal();
    const { openModalDetailBarang } = useDetailBarangModal();
    // const { openModalMutasiStok } = useMutasiStokModal();

    const [search, setSearch] = useState("");
    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const handleSortModelChange = (
        column: ParamsGetItem["column"],
        sortBy: ParamsGetItem["sortby"],
    ) => {
        setParamsItem((prev) => ({
            ...prev,
            column,
            sortby: sortBy,
        }));
    };

    const [selectedProducts, setSelectedProducts] = useState<
        SelectedProductBundling[]
    >([]);

    const isSelected = (id: number) => {
        const filteredProduct = selectedProducts.filter(
            (li) => li.id === id,
        ).length;
        if (filteredProduct > 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleSelectedProducts = (
        id: number,
        nama: string,
        harga: number,
        stok: number,
        stokPusat: number,
    ) => {
        if (isSelected(id)) {
            const newList = selectedProducts.filter((li) => li.id !== id);
            setSelectedProducts(newList);
        } else {
            setSelectedProducts((prev) => [
                ...prev,
                {
                    id,
                    nama,
                    harga,
                    stok,
                    stokPusat,
                },
            ]);
        }
    };

    const handleClearSelectedProducts = () => {
        setSelectedProducts([]);
    };

    // const handleDeleteMultipleProducts = async () => {
    //     try {
    //         const response = await axios.post("/api/item-delete", {
    //             itemId: selectedProducts.map((product) => product.id),
    //         });
    //         if (response.status === 200) {
    //             setSelectedProducts([]);
    //             Swal.fire({
    //                 title: "Item berhasil dihapus!",
    //                 position: "top-end",
    //                 showConfirmButton: false,
    //                 icon: "success",
    //                 toast: true,
    //                 timer: 3000,
    //                 timerProgressBar: true,
    //                 showCloseButton: true,
    //                 customClass: {
    //                     container: "my-swal",
    //                 },
    //             });
    //             refetchItem();
    //         } else {
    //             console.error("Failed to delete products");
    //         }
    //     } catch (error) {
    //         console.error("Error deleting products:", error);
    //     }
    // };

    const initialParamsWarehouse = {
        size: 500,
        page: 1,
        search: "",
    };

    const [paramsWarehouse, setParamsWarehouse] =
        React.useState<ParamsGetWarehouse>(initialParamsWarehouse);
    const { data: warehouse } = useWarehouse(paramsWarehouse);

    const warehouseId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalWarehouseId(user?.userId);
        }
        return null;
    }, [user]);

    const warehouseData = React.useMemo(() => {
        if (warehouseId) {
            return warehouse?.content.find((li) => li.id === warehouseId);
        }
        return warehouse?.content[0];
    }, [warehouseId, warehouse]);

    React.useEffect(() => {
        if (user && user?.warehouseId?.length > 0) {
            setParamsWarehouse((prev) => ({
                ...prev,
                userId: user.warehouseId[0],
            }));
        }
    }, [user]);

    const columns: GridColDef[] = [
        // {
        //     field: "nomer",
        //     headerName: "No",
        //     headerAlign: "center",
        //     flex: isLaptopScreen ? 1 : undefined,
        //     align: "center",
        //     renderCell: (params) => {
        //         return params.value;
        //     },
        // },

        // {
        //     field: "",
        //     headerName: "",
        //     headerAlign: "center",
        //     align: "center",
        //     minWidth: 100,
        //     sortable: false,
        //     disableColumnMenu: true,
        //     renderCell: (params) => {
        //         return (
        //             <IconButton
        //                 // disabled={(params.row.stok <= 0 && params.row.stok !== null) || params.row.isBundling > 0}
        //                 onClick={() => {
        //                     handleSelectedProducts(
        //                         params.row.id,
        //                         params.row.namaBarang,
        //                         params.row.harga,
        //                         params.row.stok,
        //                         params.row.stokPusat,
        //                     );
        //                 }}
        //                 sx={{
        //                     minWidth: "unset",
        //                     padding: "6px",
        //                     width: "fit-content",
        //                 }}
        //                 size="small"
        //                 color="primary"
        //             >
        //                 {isSelected(params.row.id) ? (
        //                     <CheckBoxIcon />
        //                 ) : (
        //                     <CheckBoxOutlineBlankIcon />
        //                 )}
        //             </IconButton>
        //         );
        //     },
        // },

        {
            field: "namaBarang",
            headerName: "Info Barang (Terjual)",
            headerAlign: "center",
            flex: isLaptopScreen ? 1.5 : undefined,
            minWidth: 235,
            valueGetter: (params) => params.value,
            renderCell: (params) => {
                return (
                    <Stack
                        direction="row"
                        paddingLeft={1}
                        spacing={1}
                        marginTop={3}
                        sx={{ marginBottom: params.row.favorite > 0 ? -1 : 3 }}
                    >
                        <Box>
                            <Avatar
                                sx={{
                                    backgroundColor: "primary.main",
                                    width: 50,
                                    height: 55,
                                }}
                                variant="rounded"
                                src={
                                    params.row.multipleGambar &&
                                    params.row.multipleGambar.length > 0
                                        ? params.row.multipleGambar[0].gambar
                                        : ""
                                }
                                onClick={() =>
                                    openModalDetailBarang(params.row)
                                }
                            >
                                {avatarAlt(params.value)}
                            </Avatar>
                            {params.row.favorite > 0 && (
                                <StarIcon
                                    sx={{
                                        position: "relative",
                                        zIndex: 2,
                                        bottom: 60,
                                        left: "70%",
                                        border: 1,
                                        borderColor: "#e7e5e4",
                                        borderRadius: "50%",
                                        padding: 0.2,
                                        color: "#fbbf24",
                                        bgcolor: "#FFFFFF",
                                    }}
                                    fontSize="medium"
                                />
                            )}
                        </Box>
                        <Stack direction="column" spacing={0.3}>
                            <Box>
                                <Tooltip
                                    title={`${params.value} ${
                                        params.row.terjual
                                            ? `(${params.row.terjual})`
                                            : ""
                                    }`}
                                >
                                    <Typography
                                        component="div"
                                        variant="subtitle2"
                                        fontWeight="bold"
                                    >
                                        {`${truncate(params.value, 20)} `}
                                        <Typography
                                            variant="subtitle2"
                                            display="inline"
                                        >
                                            {`${
                                                params.row.terjual
                                                    ? `(${params.row.terjual})`
                                                    : ""
                                            }`}
                                        </Typography>
                                    </Typography>
                                </Tooltip>
                            </Box>
                            <Box>
                                <Tooltip
                                    title={
                                        params.row.deskripsi === null
                                            ? ""
                                            : params.row.deskripsi
                                    }
                                >
                                    <Typography variant="caption">
                                        {params.row.deskripsi === null
                                            ? ""
                                            : truncate(
                                                  params.row.deskripsi,
                                                  50,
                                              )}
                                    </Typography>
                                </Tooltip>
                            </Box>
                        </Stack>
                    </Stack>
                );
            },
        },
        {
            field: "kategori",
            headerName: "Kategori",
            headerAlign: "center",
            align: "center",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 100,
            valueGetter: (params) => params.row.kategori.nama,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.row.kategori.nama}>
                        <span className="table-cell-trucate">
                            {params.row.kategori.nama}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "hargaMultiple",
            headerName: "Harga",
            headerAlign: "center",
            align: "right",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 100,
            valueGetter: (params) =>
                params.value.length > 0
                    ? Number(params.value[0].harga)
                    : params.row.harga
                    ? Number(params.row.harga)
                    : 0,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            params.value.length > 0
                                ? toRupiah(Number(params.value[0].harga))
                                : params.row.harga
                                ? toRupiah(params.row.harga)
                                : "-"
                        }
                    >
                        <span className="table-cell-trucate">
                            {params.value.length > 0
                                ? toRupiah(Number(params.value[0].harga))
                                : params.row.harga
                                ? toRupiah(params.row.harga)
                                : "-"}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "stok",
            headerName: "Stok",
            headerAlign: "center",
            align: "center",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            params.row.isBundling > 0
                                ? "Otomatis"
                                : params.value === null
                                ? "Nonaktif"
                                : params.value
                        }
                    >
                        <Typography
                            variant="subtitle2"
                            color={
                                params.value < 5 && params.value !== null
                                    ? "#ef4444"
                                    : "#76747C"
                            }
                            fontWeight={
                                params.value < 5 && params.value !== null
                                    ? 700
                                    : "normal"
                            }
                        >
                            {params.row.isBundling > 0
                                ? "Otomatis"
                                : params.value === null
                                ? "Nonaktif"
                                : params.value}
                        </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sku",
            headerName: "SKU",
            headerAlign: "center",
            align: "center",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 80,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value}>
                        <span className="table-cell-trucate">
                            {params.value}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "expAt",
            headerName: "Tanggal Kadaluarsa",
            // flex: isLaptopScreen ? 0.6 : undefined,
            align: "center",
            minWidth: 180,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            params.value
                                ? moment(params.value).format("LL")
                                : "-"
                        }
                    >
                        <Typography variant="body2">
                            {params.value
                                ? moment(params.value).format("LL")
                                : "-"}
                        </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "aksi",
            headerName: "Aksi",
            headerAlign: "center",
            align: "center",
            minWidth: 160,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                // const row: ContentGetItemResponse = params.row;

                return (
                    <Stack direction="row" spacing={2}>
                        <Button
                            variant="contained"
                            onClick={() =>
                                openModalPrintBarcode(
                                    params.row.sku,
                                    truncate(params.row.namaBarang, 24, true),
                                    `Rp${toRibuan(params.row.harga)}`,
                                )
                            }
                            size="small"
                            color="buttonblue"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <PrintIcon sx={{ width: "16px", height: "16px" }} />
                        </Button>
                        <Tooltip
                            title={
                                warehouseData?.isDropship === 1
                                    ? "Tidak bisa menghapus produk dropship"
                                    : ""
                            }
                        >
                            <span>
                                <Button
                                    disabled={
                                        (user &&
                                            !user.akses.stok.includes(26)) ||
                                        warehouseData?.isDropship === 1
                                    }
                                    variant="contained"
                                    onClick={() =>
                                        openModalHapusStok(
                                            params.id,
                                            params.row.namaBarang,
                                        )
                                    }
                                    size="small"
                                    color="buttonred"
                                    sx={{
                                        minWidth: "unset",
                                        padding: "8px",
                                        width: "32px",
                                        height: "32px",
                                    }}
                                >
                                    <DeleteIcon
                                        sx={{ width: "16px", height: "16px" }}
                                    />
                                </Button>
                            </span>
                        </Tooltip>
                    </Stack>
                );
            },
        },
    ];

    // const handleOpenModalKategori = () => {
    //     openModalKategori();
    //     refetchKategori();
    // };

    const handleOnPagination = (page: number) => {
        setParamsItem((prev) => ({
            ...prev,
            page: page + 1,
        }));
    };

    const handleOnSizeChange = (size: number) => {
        setParamsItem((prev) => ({ ...prev, size }));
    };

    const handleSearch = () => {
        setParamsItem((prev) => ({
            ...prev,
            search: search,
        }));
    };

    useEffect(() => {
        const timeoutId = setTimeout(
            () =>
                setParamsItem((prev) => ({
                    ...prev,
                    search: search,
                })),
            1000,
        );
        return () => clearTimeout(timeoutId);
    }, [search]);

    useEffect(() => {
        refetchItem();
    }, [dataItem, refetchItem]);

    useEffect(() => {
        refetchKategori();
    }, [dataKategori, refetchKategori]);

    useEffect(() => {
        if (isFetchingItems === true) {
            refetchItem();
            refetchKategori();
            cancelFetchingItems();
        }
    }, [cancelFetchingItems, isFetchingItems, refetchItem, refetchKategori]);

    useEffect(() => {
        if (kategori !== null) {
            // if (selectedKategori !== null) {
            setParamsItem((prev) => ({
                ...prev,
                kategori: kategori,
                // kategori: String(selectedKategori.id),
            }));
        } else {
            setParamsItem((prev) => ({
                ...prev,
                kategori: "",
            }));
        }
    }, [kategori]);

    useEffect(() => {
        if (warehouseIdUser) {
            setParamsItem((prev) => ({
                ...prev,
                warehouseId: warehouseIdUser && warehouseIdUser[0],
            }));
            setParamsKategori((prev) => ({
                ...prev,
                warehouseId: warehouseIdUser && warehouseIdUser[0],
            }));
        }
    }, [warehouseIdUser]);

    // const isLoading = statusKategori === "loading" || statusItem === "loading";

    if (statusKategori === "loading") {
        return (
            <Box
                position="relative"
                height={isLaptopScreen ? "100vh" : "calc(100vh - 56px)"}
            >
                <Spinner />
            </Box>
        );
    }

    return (
        <React.Fragment>
            {isPhoneScreen ? (
                <Stack
                    display="flex"
                    justifyContent="space-between"
                    direction={{ xs: "column", sm: "row", md: "row" }}
                >
                    <Stack
                        my={2}
                        direction="row"
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography fontSize="h6" fontWeight="bold">
                            Daftar Stok
                        </Typography>
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={2}
                            flexDirection="row"
                        >
                            <Box width="max-content">{dataItem?.totalItem}</Box>
                            {/* <Button
                                // disabled={
                                //     warehouseData &&
                                //     ((user && !user.akses.stok.includes(21)) ||
                                //         (warehouseData.limitItem === null
                                //             ? dataItem &&
                                //               dataItem?.totalItem >= 500
                                //                 ? true
                                //                 : false
                                //             : dataItem &&
                                //               dataItem?.totalItem >=
                                //                   warehouseData.limitItem
                                //             ? true
                                //             : false))
                                // }
                                variant="contained"
                                onClick={() => openModal()}
                                sx={{ objectFit: "contain" }}
                                startIcon={<AddIcon />}
                            >
                                Tambah
                            </Button> */}
                        </Box>
                    </Stack>
                    <Stack
                        display="flex"
                        justifyContent="space-between"
                        direction="row"
                        spacing={1}
                    >
                        {/* <Button
                            variant="outlined"
                            onClick={() => openModalMutasiStok()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <MoveToInboxIcon />
                        </Button> */}
                        <Button
                            variant="outlined"
                            onClick={() => openModalKatalog()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <AssignmentReturnedIcon />
                        </Button>
                        {/* <Button
                            variant="outlined"
                            onClick={() => openModalImport()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <FileUploadIcon />
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleOpenModalKategori}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <SettingsIcon />
                        </Button> */}
                    </Stack>
                </Stack>
            ) : isTabletScreen ? (
                <Stack
                    display="flex"
                    justifyContent="space-between"
                    marginTop={2}
                    direction={{ xs: "column", sm: "row", md: "row" }}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Daftar Stok
                    </Typography>
                    <Stack
                        display="flex"
                        justifyContent="space-around"
                        direction="row"
                        spacing={1}
                    >
                        {/* <Button
                            disabled={user && !user.akses.stok.includes(22)}
                            variant="outlined"
                            onClick={() => openModalMutasiStok()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <MoveToInboxIcon />
                        </Button> */}
                        <Button
                            disabled={user && !user.akses.stok.includes(23)}
                            variant="outlined"
                            onClick={() => openModalKatalog()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <AssignmentReturnedIcon />
                        </Button>
                        {/* <Button
                            variant="outlined"
                            onClick={() => openModalImport()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <FileUploadIcon />
                        </Button> */}
                        {/* <Button
                            disabled={user && !user.akses.stok.includes(24)}
                            variant="outlined"
                            onClick={handleOpenModalKategori}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <SettingsIcon />
                        </Button> */}
                    </Stack>
                </Stack>
            ) : (
                <Stack
                    display="flex"
                    justifyContent="space-between"
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    marginTop={2}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Daftar Stok
                    </Typography>
                    <Stack direction="row" spacing={{ xs: 0, sm: 1 }}>
                        {/* <Button
                            disabled={user && !user.akses.stok.includes(22)}
                            variant="outlined"
                            onClick={() => openModalMutasiStok()}
                            startIcon={<MoveToInboxIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Mutasi Stok
                        </Button> */}
                        <Button
                            disabled={user && !user.akses.stok.includes(23)}
                            variant="outlined"
                            onClick={() => openModalKatalog()}
                            startIcon={<AssignmentReturnedIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Buat Katalog
                        </Button>
                        {/* <Button
                            variant="outlined"
                            onClick={() => openModalImport()}
                            startIcon={<FileUploadIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Unggah Stok
                        </Button> */}
                        {/* <Button
                            disabled={user && !user.akses.stok.includes(24)}
                            variant="outlined"
                            onClick={handleOpenModalKategori}
                            startIcon={<SettingsIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Atur Kategori
                        </Button> */}
                    </Stack>
                </Stack>
            )}
            <Box alignItems="center" marginY={2}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    spacing={2}
                    alignItems="center"
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                placeholder="Cari barang..."
                                size="small"
                                value={search}
                                onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                    setSearch(event.target.value);
                                }}
                                onKeyPress={(e) => {
                                    const element =
                                        e.target as HTMLInputElement;
                                    if (e.key === "Enter") {
                                        setParamsItem((prev) => ({
                                            ...prev,
                                            search: element.value,
                                            page: 1,
                                        }));
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleSearch}>
                                                <Search />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    style: {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={9} sm={4} md={4} lg={4} xl={2}>
                            <FormControl size="small" fullWidth>
                                <InputLabel id="demo-simple-select-helper-label">
                                    Kategori
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    label="Kategori"
                                    defaultValue=""
                                    onChange={(e) =>
                                        setKategori(String(e.target.value))
                                    }
                                >
                                    <MenuItem value="">Semua</MenuItem>
                                    {dataKategori &&
                                        dataKategori?.content.map((k) => (
                                            <MenuItem key={k.id} value={k.id}>
                                                {k.nama}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                            {/* <Autocomplete
                                options={dataKategori?.content ?? []}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Kategori"
                                        variant="outlined"
                                    />
                                )}
                                getOptionLabel={(option) => option.nama}
                                size="small"
                                fullWidth
                                value={selectedKategori}
                                onChange={(
                                    _event,
                                    newKategori: IOptions | null,
                                ) => {
                                    setSelectedKategori(newKategori);
                                }}
                            /> */}
                        </Grid>
                        <Grid item xs={3} sm={1}></Grid>
                    </Grid>
                    <Box
                        display={{ xs: "none", sm: "flex" }}
                        alignItems="center"
                        gap={2}
                        flexDirection="row"
                    >
                        <Box width="max-content">
                            Total barang: {dataItem?.totalItem}
                        </Box>
                        {/* <Button
                            // disabled={
                            //     warehouseData &&
                            //     ((user && !user.akses.stok.includes(21)) ||
                            //         (warehouseData.limitItem === null
                            //             ? dataItem && dataItem?.totalItem >= 500
                            //                 ? true
                            //                 : false
                            //             : dataItem &&
                            //               dataItem?.totalItem >=
                            //                   warehouseData.limitItem
                            //             ? true
                            //             : false))
                            // }
                            variant="contained"
                            onClick={() => openModal()}
                            startIcon={<AddIcon />}
                            size="medium"
                            // fullWidth
                            sx={{
                                lineHeight: 2,
                            }}
                        >
                            Tambah
                        </Button> */}
                    </Box>
                </Stack>
            </Box>

            <Collapse in={selectedProducts.length > 0}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: 2,
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        marginTop: 2,
                        marginBottom: 1,
                        justifyContent: "space-between",
                    }}
                >
                    <Stack direction="row" alignItems="center">
                        <IconButton
                            onClick={handleClearSelectedProducts}
                            size="small"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ marginLeft: 1 }}>
                            {selectedProducts.length} terpilih
                        </Typography>
                    </Stack>

                    <Stack>
                        <Button
                            variant="contained"
                            sx={{
                                marginLeft: 2,
                                backgroundColor: "#FF7373",
                                "&:hover": {
                                    backgroundColor: "#FF7373",
                                },
                            }}
                            onClick={() =>
                                openModalHapusMultipleStok(selectedProducts)
                            }
                        >
                            Hapus Terpilih
                        </Button>
                    </Stack>
                </Box>
            </Collapse>

            {/* <ThemeProvider theme={theme}> */}
            {isPhoneScreen || isTabletScreen ? (
                dataItem && dataItem.totalElements > 0 ? (
                    <React.Fragment>
                        {dataItem.content.map((items) => (
                            <CardStokBarang
                                key={items.id}
                                data={items}
                                handleSelectedProducts={handleSelectedProducts}
                                isSelected={isSelected}
                            />
                        ))}
                        <Box
                            display="flex"
                            justifyContent="center"
                            paddingY={2}
                        >
                            <Pagination
                                color="primary"
                                count={Math.ceil(
                                    Number(
                                        dataItem &&
                                            dataItem?.totalElements /
                                                initialParamsItem.size,
                                    ),
                                )}
                                page={paramsItem.page}
                                onChange={(event, value) => {
                                    setParamsItem((prev) => ({
                                        ...prev,
                                        page: value,
                                    }));
                                }}
                                siblingCount={0}
                                // sx={{ justifyContent: "center" }}
                            />
                        </Box>
                    </React.Fragment>
                ) : (
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        paddingTop={2}
                    >
                        <BarangTidakDitemukan width="150px" height="150px" />
                        <Typography fontWeight="bold">
                            Barang tidak ditemukan
                        </Typography>
                    </Stack>
                )
            ) : (
                <Box
                    sx={{
                        // height: "80vh",
                        height: 820,
                        width: "100%",
                        marginBottom: 3,
                        backgroundColor: "#ffffff",
                        borderRadius: 1,
                        // "& .headerColumn": {
                        //     backgroundColor: "#E4EEE8",
                        //     // fontSize: "18px",
                        // },
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                        // "& .MuiDataGrid-columnSeparator": {
                        //     visibility: "hidden",
                        // },
                        // // "& .MuiDataGrid-columnHeaders": {
                        // //     borderRadius: 1,
                        // //     borderBottom: 0,
                        // // },
                        "& .MuiDataGrid-cell:focus-within": {
                            outline: "none !important",
                        },
                        "& .MuiDataGrid-iconButtonContainer": {
                            visibility: "visible",
                            width: "0 !important",
                        },
                    }}
                >
                    <DataGrid
                        pagination
                        components={{
                            ColumnUnsortedIcon: () => {
                                return <ImportExportIcon />;
                            },
                            NoRowsOverlay: NoRowsImage,
                            LoadingOverlay: LoadingTabel,
                            // Pagination: CustomPagination,
                        }}
                        rows={
                            dataItem?.content.map((item, index) => ({
                                ...item,
                                idx: index + 1,
                            })) ?? []
                        }
                        columns={columns}
                        disableColumnMenu
                        disableSelectionOnClick
                        paginationMode="server"
                        // rowsPerPageOptions={[10, 15, 20]}
                        rowsPerPageOptions={[10]}
                        onPageSizeChange={handleOnSizeChange}
                        onPageChange={handleOnPagination}
                        rowCount={dataItem?.totalElements ?? 0}
                        page={paramsItem.page - 1}
                        pageSize={paramsItem.size}
                        loading={isLoadingItem}
                        density="comfortable"
                        sortModel={sortModel}
                        onSortModelChange={(newModel) => {
                            setSortModel(newModel);
                            handleSortModelChange(
                                mapStockFieldSorting(newModel[0]?.field ?? ""),
                                newModel[0]?.sort,
                            );
                        }}
                    />
                </Box>
            )}
            <ModalStok
                refetchItem={refetchItem}
                refetchKategori={refetchKategori}
            />
            <ModalDeleteStok refetch={refetchItem} />
            <ModalDeleteMultipleStok
                refetch={refetchItem}
                handleCollapseClose={handleClearSelectedProducts}
            />
            <ModalDetailBarang />
            <ModalMutasiStok />
            {/* </ThemeProvider> */}
        </React.Fragment>
    );
};

export default TabelBarang;
